
// if(/^4[0-9]{12}(?:[0-9]{3})?$/.test(cardNumber)) return "visa";
// if(/^6(?:011|5[0-9]{2})[0-9]{12}$/.test(cardNumber)) return "discover";
// if(/^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/.test(cardNumber)) return "mastercard";
// if(/^3[47][0-9]{13}$/.test(cardNumber)) return "amex";
// if(/^(?:2131|1800|35\d{3})\d{11}$/.test(cardNumber)) return "jcb";
// if(/^3(?:0[0-5]|[68][0-9])[0-9]{11}$/.test(cardNumber)) return "diners";
// if(/^(5018|5020|5038|5893|6304|6759|6761|6762|6763)[0-9]{8,15}$/.test(cardNumber)) return "maestro";
// if(/^62[0-9]{14}[0-9]*$/.test(cardNumber) || /^81[0-9]{14}[0-9]*$/.test(cardNumber)) return "unionPay";

export default function getCreditCardType(testCard) {
  const cardNumber = testCard.replaceAll(/ /g, "");
  let amex = new RegExp('^3[47][0-9]{13}$');
  let visa = new RegExp('^4[0-9]{12}(?:[0-9]{3})?$');
  let cup1 = new RegExp('^62[0-9]{14}[0-9]*$');
  let cup2 = new RegExp('^81[0-9]{14}[0-9]*$');
  let cup3 = new RegExp('^62\\d{0,14}');

  let mastercard = new RegExp('^5[1-5][0-9]{14}$');
  let mastercard2 = new RegExp('^2[2-7][0-9]{14}$');

  let disco1 = new RegExp('^6011[0-9]{12}[0-9]*$');
  let disco2 = new RegExp('^62[24568][0-9]{13}[0-9]*$');
  let disco3 = new RegExp('^6[45][0-9]{14}[0-9]*$');

  let diners = new RegExp('^3[0689][0-9]{12}[0-9]*$');
  let jcb =  new RegExp('^35[0-9]{14}[0-9]*$');


  if (visa.test(cardNumber)) {
    return {text: "Visa", id: "", icon: "visa"};
  }
  if (amex.test(cardNumber)) {
    return {text: "AmEx", icon: "amex"};
  }
  if (mastercard.test(cardNumber) || mastercard2.test(cardNumber)) {
    return {text: "Mastercard", icon: "mastercard"};
  }
  if (disco1.test(cardNumber) || disco2.test(cardNumber) || disco3.test(cardNumber)) {
    return {text: "Discover", icon: "discover"};
  }
  if (diners.test(cardNumber)) {
    return {text: "Diners", icon: "diners"};
  }
  if (jcb.test(cardNumber)) {
    return {text: "JCB", icon: "jcb"};
  }
  if (cup1.test(cardNumber) || cup2.test(cardNumber) || cup3.test(cardNumber)) {
    return {text: "Union Pay", icon: "unionPay"};
  }
  return {text: "", icon: null};
}

export const formatCardNumber = (cardNumber) => {
  return cardNumber.replace(/\W/gi, '').replace(/\D/g, '').replace(/(.{4})/g, '$1 ').trim();

  // const cardType = getCreditCardType(cardNumber).icon;
  // console.log("cardType", cardType);
  //
  // if (cardType === "visa" || cardType === "mastercard" || cardType === "discover" || cardType === "jcb"|| cardType === "maestro") {
  //   return cardNumber.replace(/(\d{4})(?=\d)/g, '$1 ');
  // }
  //
  // if (cardType === "amex") {
  //   return cardNumber.replace(/(\d{4})(\d{6})(\d{5})/, '$1 $2 $3');
  // }
  //
  // if (cardType === "diners") {
  //   return cardNumber.replace(/(\d{4})(\d{6})(\d{4})/, '$1 $2 $3');
  // }
  //
  // if (cardType === "unionPay") {
  //   return cardNumber.replace(/(\d{4})(?=\d)/g, '$1 ');
  // }
  //
  // return cardNumber; // If no card type detected, return the number unformatted.
};